import useJwt from '../../@core/auth/jwt/useJwt'

const { jwt: authService } = useJwt({
    // login: 'https://test.cgig.jalisco.gob.mx/gestion-api/auth/login'
    login: `${process.env.REACT_APP_API}/auth/login`
})

export default authService
